
import './App.css';
import {  Box, Button, Checkbox, Grid, Modal, Typography, useMediaQuery, useTheme } from '@mui/material';
import logo from './logo.svg'
import CustomInput from './Comp/CustomInput';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useFormik } from 'formik';
import { RegSchema } from './Comp/Schema';
import { useState, useRef } from 'react';
import emailjs from "emailjs-com";
import successgif from './7efs.gif'


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {lg:400, md:400, sm:350, xs:300},
  bgcolor: "background.paper",
borderRadius:2,
  boxShadow: 24,
  p: 4,
};


function App() {
    const [open, setOpen] = useState(false);

    const handleClose = () => setOpen(false);
  const theme = useTheme()
const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const date = new Date()
  const dateValue = `${date.getDate()} - ${date.getMonth() + 1} - ${date.getFullYear()}`

    const [value, setValue] = useState("female");

    const handleRadio = (event) => {
      setValue(event.target.value);
    };
    const [value2, setValue2] = useState("female");

    const handleRadio2 = (event) => {
      setValue2(event.target.value);
    };
    const [value3, setValue3] = useState("female");

    const handleRadio3 = (event) => {
      setValue3(event.target.value);
    };

    const [isSubmitted, setIsSubmitted] = useState(false)

  const [vehicle, setVehicle] = useState("")
  const [pet, setPet] = useState("")
  const [ages1, setAges1] = useState("")
  const [ages2, setAges2] = useState("")
  const [ages3, setAges3] = useState("")
  const [ages4, setAges4] = useState("")
  const [ages5, setAges5] = useState("")

  const { values, errors, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      appliedAddress: "",
      mi:"",
      ss: "",
      dob: "",
      phoneNumber: "",
      prevAddress: "",
      landlord: "",
      phoneNumber2: "",
      rentAmount: "",
      reason: "",
      deposit:'',
      proposed:"",
      employedBy: "",
      howLong: "",
      Address1: "",
      phoneNumber3: "",
      Address2: "",
      phoneNumber4: "",
    },
    validationSchema: RegSchema,
    onSubmit: () => {
      sendRequest();
    },
  });

   const form = useRef();
  const [loading, setLoading] = useState(false)

  const sendRequest = async (event) =>{
console.log(values, value, value2, value3)
console.log(form.current)
setOpen(false)
setLoading(true)

emailjs
  .sendForm("service_xngmjdd", "template_1iz51jr", form.current, "U081QvtgAtmYgdu7x")
  .then(
    (result) => {
      setLoading(false);
      setOpen(true)
      // console.log("Email sent successfully", result.text);
      // alert("email has been sent successfully");
    },
    (error) => {
        setLoading(false);
      console.error("Email sending failed", error.text);
    }
  );


  }



  return (
    <>
      <Box sx={{ bgcolor: "#f1f1f1", pb: 7 }}>
        <Box sx={{ margin: "0 auto", width: "90%", pt: 3 }}>
          <img src={logo} width={100} />
        </Box>

        <Box
          sx={{
            margin: "0 auto",
            width: { lg: "60%", md: "60%", sm: "90%", xs: "95%" },
            bgcolor: { lg: "#fff", md: "#fff", sm: "none", xs: "#fff" },
            boxSizing: "border-box",
            p: { lg: 5, md: 5, sm: 3, xs: 3 },

            mt: { lg: 7, md: 7, sm: 4, xs: 4 },
            boxShadow: {
              lg: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              md: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              sm: "none",
              xs: "none",
            },
            borderRadius: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { lg: "30px", md: "30px", sm: "24px", xs: "24px" },
              fontFamily: "open sans",
            }}
          >
            Rental Application Form
          </Typography>
          <form onSubmit={handleSubmit} ref={form}>
            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box align="right">
                  <CustomInput
                    label="Today's Date"
                    value={dateValue}
                    name="regDate"
                  />
                </Box>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <CustomInput
                  value={values.appliedAddress}
                  error={errors.appliedAddress}
                  helperText={errors.appliedAddress}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="appliedAddress"
                  label="Address Applied For:"
                  fullWidth
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      textDecoration: "underline",
                      fontWeight: 500,
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "14px",
                        xs: "14px",
                      },
                    }}
                  >
                    {" "}
                    Applicant's Information
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Box>
                  <CustomInput
                    value={values.lastName}
                    error={errors.lastName}
                    helperText={errors.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="lastName"
                    label="Last Name:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <Box>
                  <CustomInput
                    value={values.firstName}
                    error={errors.firstName}
                    helperText={errors.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="firstName"
                    label="First Name:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.mi}
                    error={errors.mi}
                    helperText={errors.mi}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="mi"
                    label="MI:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.ss}
                    error={errors.ss}
                    helperText={errors.ss}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="ss"
                    label="SS#:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.dob}
                    error={errors.dob}
                    helperText={errors.dob}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="date"
                    id="dob"
                    label="Date of Birth:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.phoneNumber}
                    error={errors.phoneNumber}
                    helperText={errors.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="phoneNumber"
                    label="Phone#:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box>
                  <CustomInput
                    value={values.prevAddress}
                    error={errors.prevAddress}
                    helperText={errors.prevAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="prevAddress"
                    label="Previous Address:"
                    fullWidth
                  />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 3,
                    }}
                  >
                    <Typography sx={{ fontSize: "12px" }}>STREET</Typography>
                    <Typography sx={{ fontSize: "12px" }}>CITY</Typography>
                    <Typography sx={{ fontSize: "12px" }}>STATE</Typography>
                    <Typography sx={{ fontSize: "12px" }}>ZIP</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <Box>
                  <CustomInput
                    value={values.landlord}
                    error={errors.landlord}
                    helperText={errors.landlord}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="landlord"
                    label="Landlord or Mortgage Co:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.phoneNumber2}
                    error={errors.phoneNumber2}
                    helperText={errors.phoneNumber2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="phoneNumber2"
                    label="Phone (required):"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.rentAmount}
                    error={errors.rentAmount}
                    helperText={errors.rentAmount}
                    onChange={handleChange}
                    type="number"
                    onBlur={handleBlur}
                    id="rentAmount"
                    label="Rent Amount:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={9} md={6} sm={12} xs={12}>
                <Box>
                  <CustomInput
                    value={values.reason}
                    error={errors.reason}
                    helperText={errors.reason}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="reason"
                    label="Reason for Leaving:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={3} md={6} sm={12} xs={12}>
                <Box sx={{ mt: { lg: 3.5, md: 3.5, sm: 0, xs: 0 } }}>
                  <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="single"
                    value={value}
                    name="value"
                    onChange={handleRadio}
                  >
                    <FormControlLabel
                      sx={{ fontFamily: "open sans", fontSize: "14px" }}
                      value="single"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Single
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="married"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Married
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Box>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box>
                  <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
                    Proposed Occupants/Ages:
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={2.4} md={2.4} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={ages1}
                    onChange={(e) => setAges1(e.target.value)}
                    id="ages1"
                    label="1"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={2.4} md={2.4} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={ages2}
                    onChange={(e) => setAges2(e.target.value)}
                    label="2"
                    id="ages2"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={2.4} md={2.4} sm={4} xs={4}>
                <Box>
                  <CustomInput
                    value={ages3}
                    onChange={(e) => setAges3(e.target.value)}
                    label="3"
                    id="ages3"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={2.4} md={2.4} sm={4} xs={4}>
                <Box>
                  <CustomInput
                    value={ages4}
                    onChange={(e) => setAges4(e.target.value)}
                    label="4"
                    id="ages4"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={2.4} md={2.4} sm={4} xs={4}>
                <Box>
                  <CustomInput
                    value={ages5}
                    onChange={(e) => setAges5(e.target.value)}
                    label="5"
                    id="ages5"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={4.5} md={4.5} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={pet}
                    onChange={(e) => setPet(e.target.value)}
                    label="Pet:"
                    id="pet"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={4.5} md={4.5} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={vehicle}
                    onChange={(e) => setVehicle(e.target.value)}
                    label="Vehicle Type:"
                    fullWidth
                    id="vehicle"
                  />
                </Box>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={6}>
                <Box sx={{ ml: { lg: 3, md: 3, sm: 0, xs: 0 } }}>
                  <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                    Smoker:
                  </Typography>
                  <RadioGroup
                    sx={{ mt: 0.7 }}
                    row
                    fullWidth
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="single"
                    name="value2"
                    value={value2}
                    onChange={handleRadio2}
                  >
                    <FormControlLabel
                      sx={{
                        fontFamily: "open sans",
                        fontSize: {
                          lg: "14px",
                          md: "14px",
                          sm: "12px",
                          xs: "12px",
                        },
                      }}
                      value="yes"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Yes
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          No
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Box>
              </Grid>
              <Grid item lg={12} md={12} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.howMuch}
                    error={errors.howMuch}
                    helperText={errors.howMuch}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="howMuch"
                    label="How much do you have at hand now to secure the Property:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.deposit}
                    error={errors.deposit}
                    helperText={errors.deposit}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="deposit"
                    label="Earliest Possible Date of Deposit Payment:"
                    fullWidth
                    type="date"
                  />
                </Box>
              </Grid>

              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.proposed}
                    error={errors.proposed}
                    helperText={errors.proposed}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="proposed"
                    label="Proposed Move-in Date:"
                    fullWidth
                    type="date"
                  />
                </Box>
              </Grid>
              <Grid item lg={12}>
                <Box>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      textDecoration: "underline",
                      fontWeight: 500,
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "14px",
                        xs: "14px",
                      },
                    }}
                  >
                    {" "}
                    EMPLOYMENT STATUS
                  </Typography>
                </Box>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Box>
                  <RadioGroup
                    sx={{ mt: 0.7, fontSize: "12px" }}
                    row
                    fullWidth
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="Full Time"
                    name="value3"
                    value={value3}
                    onChange={handleRadio3}
                  >
                    <FormControlLabel
                      value="Full Time"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Full Time
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="Part Time"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Part Time
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="Unemployed"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Unemployed
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="Student"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Student
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="Retired"
                      control={<Radio size="small" />}
                      label={
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "14px",
                              sm: "12px",
                              xs: "12px",
                            },
                            fontFamily: "open sans",
                          }}
                        >
                          Retired
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.employedBy}
                    error={errors.employedBy}
                    helperText={errors.employedBy}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="employedBy"
                    label="Employed by:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.howLong}
                    error={errors.howLong}
                    helperText={errors.howLong}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="howLong"
                    label="how long have you work there:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.Address1}
                    error={errors.Address1}
                    helperText={errors.Address1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="Address1"
                    label="Address:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.phoneNumber3}
                    error={errors.phoneNumber3}
                    helperText={errors.phoneNumber3}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="phoneNumber3"
                    label="Phone#:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.Address2}
                    error={errors.Address2}
                    helperText={errors.Address2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="Address2"
                    label="Personal Reference:"
                    fullWidth
                  />
                </Box>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <Box>
                  <CustomInput
                    value={values.phoneNumber4}
                    error={errors.phoneNumber4}
                    helperText={errors.phoneNumber4}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    id="phoneNumber4"
                    label="Phone#:"
                    fullWidth
                  />
                </Box>
              </Grid>
            </Grid>
            <Typography
              sx={{
                fontFamily: "open sans",
                mt: 4,
                fontSize: {
                  lg: "14px",
                  sm: "12px",
                  xs: "12px",
                },
              }}
            >
              Applicant represents that all the above statements are true and
              correct and hereby authorizes verification of the above items
              including, but not limited to, the obtaining of a credit{" "}
              <Checkbox />
            </Typography>
            {/* <Typography
            sx={{
              fontFamily: "open sans",
              mt: 7,
              fontSize: { lg: "14px", md: "14px", sm: "12px", xs: "12px" },
              fontWeight: 500,
            }}
          >
            PLEASE TAKE A PICTURE OF YOUR ID AND ATTACH WHEN SENDING THE
            APPLICATION FORM FOR PROPER CHECKS THANK YOU FOR WORKING GOD BLES
          </Typography> */}
            <Box sx={{ mt: 4 }}>
              {loading ? (
                <>
                  <Button
                    type="submit"
                    // onClick={handleSubmit}
                    disabled
                    sx={{}}
                    variant="contained"
                    fullWidth
                  >
                    Submitting...
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    type="submit"
                    // onClick={handleSubmit}
                    disabled={loading}
                    variant="contained"
                    fullWidth
                  >
                    Submit
                  </Button>
                </>
              )}
            </Box>
          </form>
        </Box>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={successgif} width={200} />
            <Typography sx={{ fontWeight: 500 }}>
              Document submitted successfully
            </Typography>
            <Button sx={{ mt: 3 }} variant="contained" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default App;